import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface TiposerviciosDocumentos {
  [x: string]: any;
  id: number;
  idTiposervicio: number;
  idTipodocumento: number;
  estado: number;
  fechaActu: string;
  fechaCreat: string;
}

@Injectable({
  providedIn: 'root'
})
export class TiposerviciosDocumentosService {
  private apiUrl =  `${environment.apiUrl}/api/tiposserviciodocumentos`; 
  //private apiUrl = 'http://localhost:3000/api/tiposserviciodocumentos';

  constructor(private http: HttpClient) {}

  // Crear un nuevo registro
  createTiposervicioDocumento(data: TiposerviciosDocumentos): Observable<TiposerviciosDocumentos> {
    return this.http.post<TiposerviciosDocumentos>(this.apiUrl, data, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Obtener todos los registros
  getTiposervicioDocumentos(): Observable<TiposerviciosDocumentos[]> {
    return this.http.get<TiposerviciosDocumentos[]>(this.apiUrl, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Obtener un registro por ID (retorna array según tu comentario)
  getTiposervicioDocumentoById(id: number): Observable<TiposerviciosDocumentos[]> {
    return this.http.get<TiposerviciosDocumentos[]>(`${this.apiUrl}/${id}`, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Actualizar un registro
  updateTiposervicioDocumento(id: number, data: TiposerviciosDocumentos): Observable<TiposerviciosDocumentos> {
    return this.http.put<TiposerviciosDocumentos>(`${this.apiUrl}/${id}`, data, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Inactivar un registro
  inactivarTiposervicioDocumento(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/inactivar`, { estado: 0 }, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Activar un registro
  activarTiposervicioDocumento(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/activar`, { estado: 1 }, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Manejo de errores
  private handleError(error: any) {
    console.error('Ocurrió un error:', error);
    const message = error?.error?.message || error.message || 'Error en la solicitud.';
    return throwError(() => new Error(message));
  }
}
